// extracted by mini-css-extract-plugin
export default {"banner-wrapper":"BannerSearch_banner-wrapper__m3jwD","bannerWrapper":"BannerSearch_banner-wrapper__m3jwD","list":"BannerSearch_list__hxiuk","item":"BannerSearch_item__Lfrww"};